(function() {
  function showVideoToast(message, sectionId) {
    const toast = document.getElementById('toast-' + sectionId);
    if (!toast) return;
    toast.innerText = message;
    toast.classList.add('show');
    setTimeout(() => {
      toast.classList.remove('show');
    }, 3000);
  }

  // Listen for the standard Dawn 'cartUpdate' event.
  if (window.PUB_SUB_EVENTS && window.subscribe) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
       if (event.source === 'product-form') {
         const toasts = document.querySelectorAll('.shop-video__toast');
         toasts.forEach(t => {
           t.innerText = "Added to Cart!";
           t.classList.add('show');
           setTimeout(() => t.classList.remove('show'), 3000);
         });
       }
    });
  }
})();